import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    FETCH(meetingId) {
      var queryParams = {
        "exists[parent_resolution]": false,
        "order[position]": "ASC",
      };
      return this.get(links.MEETING_RESOLUTION_FETCH(meetingId), {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
  },
};
